import DataRoomMembersTable from './DataRoomMembersTable.component';

export default DataRoomMembersTable;
